import { render, staticRenderFns } from "./OpenComposition.vue?vue&type=template&id=5444926b&scoped=true"
import script from "./OpenComposition.vue?vue&type=script&lang=js"
export * from "./OpenComposition.vue?vue&type=script&lang=js"
import style0 from "./OpenComposition.vue?vue&type=style&index=0&id=5444926b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5444926b",
  null
  
)

export default component.exports